var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Prop, Vue } from 'vue-property-decorator';
var FileUpload = (function (_super) {
    __extends(FileUpload, _super);
    function FileUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.uploading = false;
        return _this;
    }
    FileUpload.prototype.triggerFileSelect = function () {
        this.$refs.fileInput.click();
    };
    FileUpload.prototype.handleFileChange = function (event) {
        return __awaiter(this, void 0, Promise, function () {
            var target, file, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        target = event.target;
                        file = target.files ? target.files[0] : undefined;
                        if (!file)
                            return [2];
                        if (file.size > this.maxFileSize) {
                            this.$message.error("\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 " + this.formatFileSize(this.maxFileSize));
                            target.value = '';
                            return [2];
                        }
                        if (!this.isValidFileType(file)) {
                            this.$message.error('不支持的文件类型，请选择图片或Excel文件');
                            target.value = '';
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.uploading = true;
                        return [4, this.uploadFile(file)];
                    case 2:
                        _a.sent();
                        return [3, 5];
                    case 3:
                        error_1 = _a.sent();
                        console.error('文件上传失败:', error_1);
                        this.$message.error('文件上传失败，请重试');
                        return [3, 5];
                    case 4:
                        this.uploading = false;
                        target.value = '';
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    FileUpload.prototype.isValidFileType = function (file) {
        var validImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
        var validExcelTypes = [
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];
        return validImageTypes.includes(file.type) ||
            validExcelTypes.includes(file.type) ||
            file.name.toLowerCase().endsWith('.xlsx') ||
            file.name.toLowerCase().endsWith('.xls');
    };
    FileUpload.prototype.uploadFile = function (file) {
        return __awaiter(this, void 0, Promise, function () {
            var fileData, fileUrl, fileUrl, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        fileData = {
                            name: file.name,
                            size: file.size,
                            type: file.type,
                            lastModified: file.lastModified
                        };
                        if (!this.isImageFile(file)) return [3, 2];
                        return [4, this.uploadFileToServer(file)];
                    case 1:
                        fileUrl = _a.sent();
                        this.$emit('file-selected', __assign({}, fileData, { contentType: 'image', content: fileUrl }));
                        return [3, 4];
                    case 2: return [4, this.uploadFileToServer(file)];
                    case 3:
                        fileUrl = _a.sent();
                        this.$emit('file-selected', __assign({}, fileData, { contentType: 'file', content: fileUrl }));
                        _a.label = 4;
                    case 4: return [3, 6];
                    case 5:
                        error_2 = _a.sent();
                        throw error_2;
                    case 6: return [2];
                }
            });
        });
    };
    FileUpload.prototype.uploadFileToServer = function (file) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve, reject) {
                        var formData = new FormData();
                        formData.append('file', file);
                        var xhr = new XMLHttpRequest();
                        xhr.upload.onprogress = function (event) {
                            if (event.lengthComputable) {
                                var percentComplete = (event.loaded / event.total) * 100;
                                console.log("\u4E0A\u4F20\u8FDB\u5EA6: " + percentComplete.toFixed(2) + "%");
                            }
                        };
                        xhr.onload = function () {
                            if (xhr.status === 200) {
                                try {
                                    var response = JSON.parse(xhr.responseText);
                                    if (response.success && response.data && response.data.full_path) {
                                        resolve(response.data.full_path);
                                    }
                                    else {
                                        reject(new Error(response.msg || '上传失败'));
                                    }
                                }
                                catch (e) {
                                    reject(new Error('响应格式错误'));
                                }
                            }
                            else {
                                reject(new Error("\u4E0A\u4F20\u5931\u8D25: HTTP " + xhr.status));
                            }
                        };
                        xhr.onerror = function () {
                            reject(new Error('网络错误'));
                        };
                        xhr.open('POST', '/supplierapi/upload');
                        xhr.send(formData);
                    })];
            });
        });
    };
    FileUpload.prototype.isImageFile = function (file) {
        return file.type.startsWith('image/');
    };
    FileUpload.prototype.formatFileSize = function (bytes) {
        var sizes = ['B', 'KB', 'MB', 'GB'];
        var i = Math.floor(Math.log(bytes) / Math.log(1024));
        return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
    };
    __decorate([
        Prop({ default: 'image/*,.xlsx,.xls' })
    ], FileUpload.prototype, "acceptTypes", void 0);
    __decorate([
        Prop({ default: 10 * 1024 * 1024 })
    ], FileUpload.prototype, "maxFileSize", void 0);
    FileUpload = __decorate([
        Component
    ], FileUpload);
    return FileUpload;
}(Vue));
export default FileUpload;
